module.exports = __webpack_public_path__ + "img/portfolio-preview.6aaf896.png";